import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    page: 1,
    rows: 20,
    filter: '',
    search: null,
    guests: []
  },
  mutations: {
    SET_GUESTS_FIRST(state, data) {
      state.guests = data
    },
    SET_GUESTS(state, data) {
      data.forEach((guest) => {
        state.guests.push(guest)
      })
    }
  },
  actions: {
    async getGuests({rootState, state, commit}, type) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/guestbook?page=${state.page}&rows=${state.rows}&${state.filter}&search=${state.search}`,
            method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (type === 'first') {
          commit('SET_GUESTS_FIRST', res.data.results)
        } else {
          commit('SET_GUESTS', res.data.results)
        }
        state.isLoading = false
      } else {
        state.isLoading = false
      }
    },

    async createGuest({rootState, commit}, data) {
      const payload = {
        options: {
            url: `${rootState.baseURL}/api/v1/guestbook`,
            method: 'POST',
            data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 201) {
        rootState.isLoading = false
        rootState.showPopUpModal = true
        rootState.popUpModalTitle = 'Berhasil'
        rootState.popUpModalDescription = 'Tamu berhasil ditambahkan'
        rootState.popUpModalIsSuccess = true
      } else {
        rootState.isLoading = false
        rootState.showPopUpModal = true
        rootState.popUpModalTitle = 'Oops'
        rootState.popUpModalDescription = 'Tamu gagal ditambahkan'
        rootState.popUpModalIsSuccess = false
      }
    }
  }
})